import jiraQaImportApi from "../api/jiraQaImport";

type S = { isLoading: boolean; issueList: any[]; selectedIssue: any };

const state: S = {
  isLoading: false,
  issueList: [],
  selectedIssue: null,
};

const mutations = {
  setIsLoading(state: S, value: boolean) {
    state.isLoading = value;
  },
  setIssueList(state: S, issueList: any[]) {
    state.issueList = issueList;
  },
  setSelectedIssue(state: S, issue: any) {
    state.selectedIssue = issue;
  },
  clearSelectedIssue(state: S) {
    state.selectedIssue = null;
  },
};

const actions = {
  async loadIssues({ commit }: any) {
    commit("setIsLoading", true);
    try {
      const issueList = await jiraQaImportApi.list();
      commit("setIssueList", issueList);
    } finally {
      commit("setIsLoading", false);
    }
  },

  async createReleaseNote(_context: any, { issueKey, packId, templateType, applicationDropdownValueId, primaryActivityDropdownValueId, serviceAreaAttributeList, userRole }: { issueKey: string; packId: number; templateType: string; applicationDropdownValueId?: number; primaryActivityDropdownValueId?: number; serviceAreaAttributeList?: number[]; userRole?: string[] }) {
    return jiraQaImportApi.create(issueKey, packId, templateType, applicationDropdownValueId, primaryActivityDropdownValueId, serviceAreaAttributeList, userRole);
  },
};

export default {
  actions,
  mutations,
  namespaced: true,
  state,
};
